<template>
  <article class="article">
    <h2 class="title">{{ title }}</h2>
    <span class="text"
          :class="{limit: !readMoreActivated && htmlParser(description).length > 250}"
          v-html="description" />
    <a class="read-more"
       v-if="!readMoreActivated && htmlParser(description).length > 250"
       @click="activateReadMore">
      {{ $t('READ_MORE') }}
    </a>
  </article>
</template>

<script>
import { htmlParser } from '@/utilityFunctions'

export default {
  name: 'entry-info-component',
  props: {
    openByDefault: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      readMoreActivated: this.openByDefault
    }
  },
  methods: {
    htmlParser,
    activateReadMore () {
      this.readMoreActivated = true
    }
  }
}
</script>

<style lang="scss" scoped>
.slide-fade-enter-active {
  transition: all .8s ease;
}

.slide-fade-enter {
  opacity: 0;
}

.slide-fade-leave-active {
  opacity: 1;
}
</style>
